module.exports = __webpack_public_path__ + "files/8ecb170515be94412d6063e876d65594.png";